
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner-with-us",
      function () {
        return require("private-next-pages/partner-with-us.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partner-with-us"])
      });
    }
  